"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "FunctionSymbol___StyledSvg",
  componentId: "sc-1hrzncu-0"
})(["color:", ";height:", ";width:", ";font-size:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
}, function (p) {
  return p._css4;
});

function FunctionSymbol(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size,
    _css4: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.907 8.497l-.67 5.683c-.07.583-.205 1.084-.407 1.503a2.856 2.856 0 01-.823 1.032c-.347.27-.77.468-1.268.595-.497.127-1.077.19-1.739.19v-1.066c0-.418.213-.627.638-.627.215 0 .414-.03.597-.091.183-.06.344-.157.484-.29.14-.131.256-.305.347-.52.092-.214.156-.476.194-.784l.67-5.584-.993-.149c-.301-.066-.452-.236-.452-.512v-.834h1.623l.145-1.223c.134-1.1.543-1.93 1.227-2.486.683-.556 1.687-.834 3.01-.834v1.115c0 .215-.05.365-.149.45-.1.086-.26.128-.48.128-.22 0-.424.03-.61.091-.185.06-.35.157-.496.29a1.556 1.556 0 00-.363.52 2.715 2.715 0 00-.202.784l-.153 1.165H9.41v1.454H6.907zm5.596 1.784l-2.72-4.105h1.921c.146 0 .253.02.323.062.07.04.132.108.186.202l1.735 2.833a2.34 2.34 0 01.101-.28c.04-.094.09-.188.15-.282l1.396-2.23a.782.782 0 01.201-.231.436.436 0 01.259-.074h1.832l-2.728 4.014 2.84 4.46h-1.92a.516.516 0 01-.351-.115 1.083 1.083 0 01-.222-.265l-1.76-2.948a1.603 1.603 0 01-.202.495l-1.55 2.453a1.31 1.31 0 01-.217.26.457.457 0 01-.323.12H9.67l2.833-4.37z",
    fill: "currentColor"
  }));
}

var _default = FunctionSymbol;
exports["default"] = _default;